import { ReactNode } from 'react'

import { Text } from '@/components/domain/rules'
import { useTranslation } from '@/i18n/configs'

export const ServiceTerms = () => {
  const t = useTranslation()

  return (
    <div className="px-16">
      <div aria-labelledby="1-definition">
        <>
          {((): ReactNode => {
            const retElements: ReactNode[] = []
            for (let i = 1; ; i++) {
              const title = t(`service_terms.content.${i}.title`, {
                defaultValue: '',
              })
              if (!title) {
                break
              }
              const body = t(`service_terms.content.${i}.body`, {
                defaultValue: '',
              })
              if (!body) {
                break
              }
              retElements.push(
                <div key={title} className="pb-16 last:pb-48">
                  <Text id="1-definition" as="h2">
                    {title}
                  </Text>
                  <Text as="p" className="whitespace-pre-wrap">
                    {body}
                  </Text>
                </div>
              )
            }
            return retElements
          })()}
        </>
      </div>
    </div>
  )
}
